import React from "react";
import Badge from "../../../components/ui-components/Badge";
import { fmtSignedMoney, fmtPct } from "../format";
import LensCompositionBar from "./LensCompositionBar";

// Each ownership perspective, with a plain-language description of what it answers
// (so the tab reads as owners, not just a code + numbers).
const LENSES = {
  organisation: { title: "Organisation", desc: "Which team or department the change lands on" },
  financial: { title: "Financial", desc: "Which cost category (e.g. COGS, R&D) it falls under" },
  technical: { title: "Technical component", desc: "Which system or component drove it" },
  use_case: { title: "Use case", desc: "Which product or use case it serves" },
};

export default function FourPerspectiveAllocationPanel({ lenses = [] }) {
  if (!lenses.length) return <div className="text-text-3">No allocation computed.</div>;
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      {lenses.map((l) => {
        const meta = LENSES[l.dimensionCode] || { title: l.dimensionCode, desc: "" };
        // Only owners whose spend actually moved — a whole hierarchy of €0 rows is noise.
        const rows = [...(l.rows || [])]
          .filter((r) => Math.abs(r.deltaCost || 0) >= 0.005)
          .sort((a, b) => Math.abs(b.deltaCost) - Math.abs(a.deltaCost));
        return (
          <div key={l.dimensionCode} className="rounded-card border border-card-bd bg-card p-5">
            <div className="mb-2 flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="font-medium text-text-2">{meta.title}</div>
                {meta.desc && <div className="text-[12px] text-text-3">{meta.desc}</div>}
              </div>
              <div className="flex shrink-0 items-center gap-2 text-[12px] text-text-3">
                {Number.isFinite(l.coveragePct) && <span>{fmtPct(l.coveragePct)} coverage</span>}
                {l.confidenceLabel && <Badge status="custom" label={l.confidenceLabel} size="sm" />}
              </div>
            </div>
            {rows.length ? (
              <ul className="mt-1 space-y-1">
                {rows.map((r) => (
                  <li key={r.ownerNodeId} className="flex items-center justify-between text-[13px]">
                    <span className="truncate text-text-2">{r.label || `Owner #${r.ownerNodeId}`}</span>
                    <span className="tabular-nums font-medium">{fmtSignedMoney(r.deltaCost)}</span>
                  </li>
                ))}
              </ul>
            ) : <div className="text-[13px] text-text-3">No owner movement on this perspective.</div>}
            <LensCompositionBar rows={rows} />
          </div>
        );
      })}
    </div>
  );
}
